import React from 'react';
import { Row, Col, Button } from 'antd';
import { I18n } from '@aws-amplify/core';

interface IButtonsProps {
	isLoading?: boolean;
	currentStep: number;
	steps: any;
	next: () => void;
	prev: () => void;
}

export const Buttons: React.FC<IButtonsProps> = ({ isLoading, currentStep, steps, next, prev }) => (
	<Row justify="center">
		{currentStep > 0 && (
			<Col span={'auto'}>
				<Button
					style={{
						margin: '0 8px',
						float: 'right'
					}}
					onClick={prev}
				>
					{I18n.get('Previous')}
				</Button>
			</Col>
		)}
		{currentStep < steps.length - 1 && (
			<Col span={'auto'}>
				<Button type="primary" onClick={next} style={{ float: 'left' }}>
					{I18n.get('Next')}
				</Button>
			</Col>
		)}
		{currentStep === steps.length - 1 && (
			<Col span={'auto'}>
				<Button type="primary" htmlType="submit" style={{ float: 'left' }} loading={isLoading}>
					{I18n.get('Finish')}
				</Button>
			</Col>
		)}
	</Row>
);
